import { useMemo, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { leaderboard, weeksOf, dayLabel, fmtDur, fmtHours } from "../lib/pickerSheet";
import { fmtNum, slug } from "../lib/format";

const SORTS = [["lost", "Lost time"], ["gapCount", "Large gaps"], ["gapTime", "Gap time"], ["lostPerDay", "Lost / day"]];
const medal = ["bg-rose-500/20 text-rose-300 border-rose-500/40", "bg-amber-500/20 text-amber-300 border-amber-500/40", "bg-yellow-500/10 text-yellow-200 border-yellow-500/30"];

export const LostLeaderboard = ({ users, onOpen }) => {
  const weeks = useMemo(() => weeksOf(users), [users]);
  const [week, setWeek] = useState(weeks[weeks.length - 1]);
  const [by, setBy] = useState("lost");
  const wk = weeks.includes(week) ? week : weeks[weeks.length - 1];
  const rows = useMemo(() => leaderboard(users, wk).sort((a, b) => b[by] - a[by]), [users, wk, by]);
  const max = rows[0]?.[by] || 1;
  return (
    <div className="panel" data-testid="lost-leaderboard">
      <div className="flex flex-wrap items-center gap-3 p-5 border-b border-slate-800">
        <div className="mr-auto">
          <h3 className="font-display text-lg font-semibold text-slate-100">Lost time leaderboard</h3>
          <p className="text-xs text-slate-500">Worst first · week commencing</p>
        </div>
        <Select value={wk} onValueChange={setWeek}>
          <SelectTrigger data-testid="leaderboard-week-select" className="h-9 w-[170px] bg-[#0B0F19] border-slate-700 text-slate-100 font-mono text-xs"><SelectValue /></SelectTrigger>
          <SelectContent className="max-h-80">{[...weeks].reverse().map((w) => <SelectItem key={w} value={w} className="font-mono text-xs">{dayLabel(w)} {w.slice(0, 4)}</SelectItem>)}</SelectContent>
        </Select>
        <div className="inline-flex rounded-lg border border-slate-800 bg-[#0B0F19] p-1">
          {SORTS.map(([k, l]) => (
            <button key={k} data-testid={`leaderboard-sort-${k}`} onClick={() => setBy(k)} className={`px-3 py-1.5 text-xs rounded-md transition-colors ${by === k ? "bg-slate-700 text-white" : "text-slate-400 hover:text-slate-200"}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-slate-800">{["#", "Picker", "Shift", "Days", "Picks", "Hours", "Late", "Early", "Gaps", "Gap time", "Lost time", ""].map((h, i) => <th key={i} className="text-left px-3 py-3 font-mono text-xs uppercase tracking-wider text-slate-500 whitespace-nowrap first:pl-5">{h}</th>)}</tr></thead>
          <tbody>{rows.map((r, i) => (
            <tr key={r.id} data-testid={`leaderboard-row-${slug(r.id)}`} onClick={() => onOpen(r.id)} className="border-b border-slate-800/60 hover:bg-slate-800/40 cursor-pointer transition-colors">
              <td className="pl-5 py-2.5"><span className={`inline-flex h-6 w-6 items-center justify-center rounded-full border text-[11px] font-mono ${medal[i] || "border-slate-700 text-slate-400"}`}>{i + 1}</span></td>
              <td className="px-3 text-slate-100 font-medium whitespace-nowrap">{r.id}</td>
              <td className="px-3 text-xs text-slate-400">{r.shift}</td>
              <td className="px-3 font-mono text-slate-400">{r.days.length}</td>
              <td className="px-3 font-mono text-slate-300">{fmtNum(r.picks)}</td>
              <td className="px-3 font-mono text-slate-300">{fmtHours(r.worked)}</td>
              <td className="px-3 font-mono text-amber-300">{fmtDur(r.late)}</td>
              <td className="px-3 font-mono text-amber-300">{fmtDur(r.early)}</td>
              <td className="px-3 font-mono text-rose-300/80">{r.gapCount}</td>
              <td className="px-3 font-mono text-rose-300/80">{fmtDur(r.gapTime)}</td>
              <td className="px-3 font-mono text-rose-300 font-medium whitespace-nowrap">{fmtDur(r.lost)}</td>
              <td className="px-3 w-40"><div className="h-1.5 rounded bg-slate-800"><div className="h-1.5 rounded bg-rose-500" style={{ width: `${(r[by] / max) * 100}%` }} /></div></td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
};
